// src/auth/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { Spin } from "antd";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userGroups, setUserGroups] = useState([]);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const authSession = await fetchAuthSession();

        if (!authSession || !authSession.tokens?.idToken) {
          throw new Error("No session found");
        }

        setIsAuthenticated(true);

        // Decode the ID token to extract groups
        const idToken = authSession.tokens.idToken.toString();
        const payload = JSON.parse(atob(idToken.split(".")[1]));
        const groups = payload["cognito:groups"] || [];
        if (groups.length > 0) {
          console.log("[ProtectedRoute] Cognito group names:", groups);
        } else {
          console.warn("[ProtectedRoute] No Cognito groups assigned to user.");
        }
        setUserGroups(groups);
      } catch (err) {
        console.error("Auth check failed:", err);
        setIsAuthenticated(false);
      }
    };

    checkSession();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div>
        <Spin size="large" style={{ left: "50%", marginTop: "50px" }} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If roles are required, check groups
  if (allowedRoles.length > 0) {
    const isAllowed = allowedRoles.some((role) => userGroups.includes(role));
    if (!isAllowed) {
      return <Navigate to="/home" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
